<div class="sidenav-content">
  <div class="bcontainer2">
    <div class="main-content">


    <div class="spacer2"></div>

    <div class="containter">
      <div class="mfhd">
        <i
          class="fa fa-angle-left"
          aria-hidden="true"
          style="padding-right: 5px"
          title="Go back to previous page"
        ></i
        >Reminders
        <div
          class="page-description"
          style="
            color: #9c9b9b;
            font-size: 14px;
            margin-top: 8px;
            margin-bottom: 16px;
          "
        >
          XDBrain understands user input and sets helpful reminders for future
          tasks.
        </div>
      </div>

      <div class="spacer2"></div>

      <div class="example-container">
        <!-- *ngIf="remlist?.data?.reminders?.length" -->
        <table
          mat-table
          [dataSource]="remlist?.data?.reminders"
          class="mat-elevation-z8"
        >
          <ng-container matColumnDef="reminder">
            <th
              mat-header-cell
              *matHeaderCellDef
              title="The reminder content or message"
            >
              Reminder
            </th>
            <td mat-cell *matCellDef="let element" [title]="element?.reminder">
              {{ element?.reminder }}
            </td>
          </ng-container>

          <ng-container matColumnDef="info">
            <th
              mat-header-cell
              *matHeaderCellDef
              title="Transaction details including ID and creation date"
            >
              Details
            </th>
            <td mat-cell *matCellDef="let element">
              <span [title]="'Trace ID: ' + element?.transactionNumber">{{
                element?.transactionNumber
              }}</span
              ><br />
              <span [title]="'Date: ' + element?.date">{{
                element?.date
              }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="frequency">
            <th
              mat-header-cell
              *matHeaderCellDef
              title="How often this reminder repeats"
            >
              Frequency
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              [title]="'Frequency: ' + element?.frequency"
            >
              {{ element?.frequency }}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th
              mat-header-cell
              *matHeaderCellDef
              title="Available actions for this reminder"
            >
              Actions
            </th>
            <td mat-cell *matCellDef="let element">
              <i
                class="fa fa-check-circle"
                aria-hidden="true"
                style="
                  cursor: pointer;
                  color: #1b8a9e;
                  font-size: 16px;
                  margin-right: 8px;
                "
                matTooltip="Mark as done - this will complete the reminder"
                (click)="markAsDone(element)"
              ></i>
              <i
                class="fa fa-clock"
                aria-hidden="true"
                style="cursor: pointer; color: #dfa702; font-size: 16px"
                matTooltip="Snooze reminder - postpone for later"
                (click)="snoozeReminder(element)"
              ></i>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <!-- No data message -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length" style="text-align: center; height: 50vh;">
            {{ loading ? 'Loading...' : 'No data found' }}
          </td>
        </tr>

        </table>
      </div>
    </div>

    </div>
  </div>
</div>
